import {
  shiftAuctionBidBodySchema,
  type ShiftAuctionBidResponse,
  shiftAuctionBidResponseSchema,
} from "@clipboard-health/contract-worker-app-bff";
import { post } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type ComputedArrivalData } from "@src/appV2/redesign/ArrivalTime/computeArrivalData";
import { toShiftAuctionBidBody } from "@src/appV2/redesign/Shift/ShiftAuction/utils/toShiftAuctionBidBody";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";

const SHIFT_AUCTION_BIDS_PATH = "/shift-auction-bids";
const SHIFT_AUCTION_BIDS_URL = `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}${SHIFT_AUCTION_BIDS_PATH}`;

interface CreateShiftAuctionBidRequest {
  shiftAuctionId: string;
  bidAmount: number;
  computedArrivalData: ComputedArrivalData | undefined;
}

export function useCreateShiftAuctionBid(
  options: UseMutationOptions<
    ShiftAuctionBidResponse,
    AxiosError,
    CreateShiftAuctionBidRequest
  > = {}
) {
  return useMutation({
    mutationFn: async ({
      shiftAuctionId,
      bidAmount,
      computedArrivalData,
    }: CreateShiftAuctionBidRequest) => {
      const response = await post({
        url: SHIFT_AUCTION_BIDS_URL,
        data: toShiftAuctionBidBody({ shiftAuctionId, bidAmount, computedArrivalData }),
        requestSchema: shiftAuctionBidBodySchema,
        responseSchema: shiftAuctionBidResponseSchema,
      });

      // Need a cast here because it otherwise does not resolve workerIdSchema correctly
      return response.data as ShiftAuctionBidResponse;
    },
    ...options,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.POST_SHIFT_AUCTION_BID_FAILURE,
      ...options.meta,
    },
  });
}
